
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.6 1.6a.8.8 0 01.8-.8h11.2a.8.8 0 010 1.6v6.4a1.6 1.6 0 01-1.6 1.6H7.8v3.2h.8a.8.8 0 010 1.6H5.4a.8.8 0 110-1.6h.8v-3.2H3a1.6 1.6 0 01-1.6-1.6V2.4a.8.8 0 01-.8-.8zm10.4.8H3v6.4h8V2.4z","fill":"#B5B5B5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.01 4.16a.683.683 0 01.046.892l-1.199 1.5c-.456.572-1.23.658-1.779.2l-.988-.827a.174.174 0 00-.239.012L4.744 7.04a.526.526 0 01-.8-.05.683.683 0 01.045-.893l1.108-1.102c.47-.468 1.17-.501 1.673-.08l.987.826a.175.175 0 00.255-.029l1.199-1.5a.526.526 0 01.8-.052z","fill":"#B5B5B5"}})])
          )
        }
      }
    